import React, { Component } from "react";
import { Card, Button, Image } from "semantic-ui-react";
import PropTypes from "prop-types";
import ApexCharts from "apexcharts";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import { connect } from "react-redux";
import { solveProblemAction } from "actions/changeActiveItemActions";

let dpWaveFormOptions = {
  series: [{ data: [] }],
  chart: {
    type: "line",
  },
  colors: [Constants.BLUE_HEX],
  markers: {
    size: 0
  },
  dataLabels: {
    enabled: false
  },
  title: {
    text: Strings.WAVE_FORM,
    align: "center",
    style: {
      fontSize: "14px",
      fontFamily: "Helvetica, Arial, sans-serif"
    }
  },
  stroke: {
    curve: "straight",
    width: 2
  },
  xaxis: {
    type: "numeric",
    title: {
      text: Strings.TIME_NS
    },
    crosshairs: {
      show: "true"
    },
    labels: {
      show: true,
      style: {
        fontSize: "14px",
        fontFamily: "Helvetica, Arial, sans-serif",
        cssClass: "apexcharts-xaxis-label",
      }
    }
  },
  yaxis: {
    min: -1,
    max: 4,
    tickAmount: 8,
    labels: {
      show: true,
      formatter: function (val) {
        return val.toFixed(2) + " V";
      },
      style: {
        colors: [],
        fontSize: "14px",
        fontFamily: "Helvetica, Arial, sans-serif",
        fontWeight: 400,
        cssClass: "apexcharts-yaxis-label",
      }
    },
    title: {
      text: Strings.VOLTAGE_V
    },
  },
  annotations: {
    position: "front",
    xaxis: []
  }
};

export class ProblemCard extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      waveImg: "",
      isToggleActive: false
    };
  }

  getProblemHeader = () => {
    // Protocol
    if (this.props.problem.type === Constants.RETRIES_ERROR_TYPE) {
      return (
        this.props.problem._id.includes(Constants.RETRIES_UPDATE_ERROR_TYPE) ? (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.DEVICE_UPDATE_WITH_RETRIES}
          </Card.Header>
        ) : (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.DEVICE_WITH_RETRIES}
          </Card.Header>
        )
      );
    }
    else if (this.props.problem.type === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return (
        this.props.problem._id.includes(Constants.DIAGNOSTIC_UPDATE_ERROR_TYPE) ? (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.DEVICE_UPDATE_WITH_DIAGNOSTIC}
          </Card.Header>
        ) : (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.DEVICE_WITH_DIAGNOSTIC}
          </Card.Header>
        )
      );
    }
    else if (this.props.problem.type === Constants.FAULT_ERROR_TYPE) {
      return (
        this.props.problem._id.includes(Constants.FAULT_UPDATE_ERROR_TYPE) ? (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.DEVICE_UPDATE_WITH_FAULT}
          </Card.Header>
        ) : (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.DEVICE_WITH_FAULT}
          </Card.Header>
        )
      );
    }
    else if (this.props.problem.type === Constants.ERROR_FRAME_TYPE) {
      return (
        this.props.problem._id.includes(Constants.ERROR_FRAME_UPDATE_TYPE) ? (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.ERROR_FRAMES_UPDATE_STRING}
          </Card.Header>
        ) : (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.ERROR_FRAMES_STRING}
          </Card.Header>
        )
      );
    }
    else if (this.props.problem.type === Constants.MISSING_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_MISSING}
        </Card.Header>
      );
    }
    // Meio Fisico
    else if (this.props.problem.type === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_ATTENTION_SIGNAL}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.BAD_SIGNAL_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_BAD_SIGNAL}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_CAPACITIVE_EFFECT}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.NOISE_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.NOISE}
        </Card.Header>
      );
    }
    else {
      return "";
    }
  }

  getProblemHeaderUpdate = () => {
    // Protocol
    if (this.props.problem.type === Constants.RETRIES_ERROR_TYPE) {
      return (
        this.props.problem._idUpdate.includes(Constants.RETRIES_UPDATE_ERROR_TYPE) ? (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.DEVICE_UPDATE_WITH_RETRIES}
          </Card.Header>
        ) : (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.DEVICE_WITH_RETRIES}
          </Card.Header>
        )
      );
    }
    else if (this.props.problem.type === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return (
        this.props.problem._idUpdate.includes(Constants.DIAGNOSTIC_UPDATE_ERROR_TYPE) ? (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.DEVICE_UPDATE_WITH_DIAGNOSTIC}
          </Card.Header>
        ) : (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.DEVICE_WITH_DIAGNOSTIC}
          </Card.Header>
        )
      );
    }
    else if (this.props.problem.type === Constants.FAULT_ERROR_TYPE) {
      return (
        this.props.problem._idUpdate.includes(Constants.FAULT_UPDATE_ERROR_TYPE) ? (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.DEVICE_UPDATE_WITH_FAULT}
          </Card.Header>
        ) : (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.DEVICE_WITH_FAULT}
          </Card.Header>
        )
      );
    }
    else if (this.props.problem.type === Constants.ERROR_FRAME_TYPE) {
      return (
        this.props.problem._idUpdate.includes(Constants.ERROR_FRAME_UPDATE_TYPE) ? (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.ERROR_FRAMES_UPDATE_STRING}
          </Card.Header>
        ) : (
          <Card.Header style={{ marginBottom: "2px" }}>
            {Strings.ERROR_FRAMES_STRING}
          </Card.Header>
        )
      );
    }
    else {
      return "";
    }
  }

  formatTime = () => {
    let ntp = this.props.problem.ntp;

    if (ntp !== null && ntp === true) {
      let parsedMillis = Date.parse(this.props.problem.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (this.props.problem.time !== undefined && this.props.problem.time !== null) {
      const eventTimeInMillis = this.props.problem.time * 1000;
      const timeNow = this.props.nowMillis;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  formatTimeUpdate = () => {
    let ntp = this.props.problem.ntp;

    if (ntp !== null && ntp === true) {
      let parsedMillis = Date.parse(this.props.problem.timeUpdate);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (this.props.problem.timeUpdate !== undefined && this.props.problem.timeUpdate !== null) {
      const eventTimeInMillis = this.props.problem.timeUpdate * 1000;
      const timeNow = this.props.nowMillis;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  getProblemMeta = () => {
    let problemDate = this.formatTime();

    return (
      <Card.Meta>
        <strong>
          {Strings.DETECTED_ON}
          {problemDate}
        </strong>
      </Card.Meta>
    );
  }

  getProblemMetaUpdate = () => {
    let problemDate = this.formatTimeUpdate();

    return (
      <Card.Meta>
        <strong>
          {Strings.DETECTED_ON}
          {problemDate}
        </strong>
      </Card.Meta>
    );
  }

  getProblemDescription = () => {
    if (this.props.problem.type === Constants.RETRIES_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p>
              <b>{Strings.ADDRESS}:</b> {this.props.problem.address} <br />
              <b>{Strings.RETRIES_DN}</b>{this.props.problem.retries} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p><b>{Strings.ADDRESS}:</b> {this.props.problem.address}</p>
            <b>{Strings.DESCRIPTION}:</b>
            <p>
              {this.props.problem.description.map((description, index) => (
                <span key={index}>• {description}<br /></span> 
              ))}
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.FAULT_ERROR_TYPE || this.props.problem.type === Constants.FAULT_UPDATE_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p>
              <b>{Strings.ADDRESS}:</b> {this.props.problem.address} <br />
              <b>{Strings.FAULT_DN}</b>{this.props.problem.faults} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.ERROR_FRAME_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p>
              <b>{Strings.ERROR_FRAME}</b>{this.props.problem.contErrorFrame} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.MISSING_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p><b>{Strings.ADDRESS}:</b> {this.props.problem.address}</p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p>
              <b>{Strings.ADDRESS}:</b> {this.props.problem.address} <br />
              <b>{Strings.AMPLITUDE}: </b>{(this.props.problem.amplitude).toFixed(2)} {Strings.VOLTAGE}<br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.BAD_SIGNAL_PROBLEM_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p>
              <b>{Strings.ADDRESS}:</b> {this.props.problem.address} <br />
              <b>{Strings.AMPLITUDE}: </b>{(this.props.problem.amplitude).toFixed(2)} {Strings.VOLTAGE}<br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p>
              <b>{Strings.ADDRESS}:</b> {this.props.problem.address} <br />
              <b>{Strings.AMPLITUDE}: </b>{(this.props.problem.amplitude).toFixed(2)} {Strings.VOLTAGE}<br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.NOISE_PROBLEM_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p>
              <b>{Strings.AMPLITUDE}: </b>{(this.props.problem.amplitude).toFixed(2)} {Strings.VOLTAGE}<br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else {
      return "";
    }
  }

  getProblemDescriptionUpdate = () => {
    if (this.props.problem.type === Constants.RETRIES_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p>
              <b>{Strings.ADDRESS}:</b> {this.props.problem.address} <br />
              <b>{Strings.RETRIES_DN}</b>{this.props.problem.retriesUpdate} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p><b>{Strings.ADDRESS}:</b> {this.props.problem.address}</p>
            <b>{Strings.DESCRIPTION}:</b>
            <p>
              {this.props.problem.descriptionUpdate.map((descriptionUpdate, index) => (
                <span key={index}>• {descriptionUpdate}<br /></span> 
              ))}
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.FAULT_ERROR_TYPE || this.props.problem.type === Constants.FAULT_UPDATE_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p>
              <b>{Strings.ADDRESS}:</b> {this.props.problem.address} <br />
              <b>{Strings.FAULT_DN}</b>{this.props.problem.faultsUpdate} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.ERROR_FRAME_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p>
              <b>{Strings.ERROR_FRAME}</b>{this.props.problem.contErrorFrameUpdate} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else {
      return "";
    }
  }

  handleSolvedButtonClick = async () => {
    this.props.onProblemSolve(true, this.props.problem);
  }

  // Scope DP events related functions
  getFormatedDNOptions = (wave, dpOptions) => {
    let options = {};

    if (wave[wave.length - 1][0] < 1000) {
      // Set the time values to nanosseconds
      options = {
        ...dpOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_NS
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }
    else if (wave[wave.length - 1][0] >= 1000
      && wave[wave.length - 1][0] < 1000000) {
      // Set the time values to microsseconds
      options = {
        ...dpOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_US
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }
    else if (wave[wave.length - 1][0] >= 1000000) {
      // Set the time values to millisseconds
      options = {
        ...dpOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_MS
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }

    return options;
  }

  formatDNWaveTimes = (wave) => {
    if (!wave || wave.length === 0) {
      return wave;
    }

    const lastTime = wave[wave.length - 1][0];

    if (lastTime < 1000) {
      return wave.map(point => [...point]);
    }

    if (lastTime >= 1000 && lastTime < 1000000) {
      return wave.map(point => [point[0] / 1000, point[1]]);
    }

    return wave.map(point => [point[0] / 1000000, point[1]]);
  }

  getBAOscilloscopeImgURI = async (wave) => {
    if (wave !== null && wave !== undefined) {

      document.getElementById("chart").style.display = "block";

      // Render the chart
      let chart = new ApexCharts(document.querySelector("#chart"), dpWaveFormOptions);
      chart.render();

      // Render the wave B - A to get its imgURI
      let options = this.getFormatedDNOptions(wave, dpWaveFormOptions);

      options = {
        ...options,
        title: {
          text: Strings.WAVE_DN,
          align: "center",
          style: {
            fontSize: "14px",
            fontFamily: "Helvetica, Arial, sans-serif"
          }
        },
        colors: [Constants.BLUE_HEX],
        series: [
          { name: Strings.WAVE_DN, data: this.formatDNWaveTimes(wave) }
        ]
      };

      chart.updateOptions(options, false, false, false);

      let imgURIObj = await chart.dataURI();

      document.getElementById("chart").style.display = "none";

      chart.destroy();

      return imgURIObj.imgURI;
    }
    else {
      return Constants.LOADING_IMG;
    }
  }

  setImage = async () => {

    let wave = "data:,";

    if (this.props.problem.type === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE
      || this.props.problem.type === Constants.BAD_SIGNAL_PROBLEM_TYPE 
      || this.props.problem.type === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE
      || this.props.problem.type === Constants.NOISE_PROBLEM_TYPE) {

      while (wave === "data:,") {
        wave = await this.getBAOscilloscopeImgURI(this.props.problem.wave);
      }
    }

    this.setState({ waveImg: wave }, () => {
      let waveImgElement = document.getElementById(this.props.problem._id + " / imgWave");
      waveImgElement.style.visibility = "visible";
      waveImgElement.style.display = "block";
    });
  }

  componentDidMount = () => {
    if (
      this.props.problem.type === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE
      || this.props.problem.type === Constants.BAD_SIGNAL_PROBLEM_TYPE
      || this.props.problem.type === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE
      || this.props.problem.type === Constants.NOISE_PROBLEM_TYPE
    ) {
      this.setImage();
    }
  }

  render() {
    let _idUpdate = this.props.problem._idUpdate

    if (_idUpdate === undefined) {
      _idUpdate = ""
    }
    if (
      this.props.problem.type === Constants.RETRIES_ERROR_TYPE
      || this.props.problem.type === Constants.DIAGNOSTIC_ERROR_TYPE
      || this.props.problem.type === Constants.FAULT_ERROR_TYPE
      || this.props.problem.type === Constants.ERROR_FRAME_TYPE
      || this.props.problem.type === Constants.MISSING_ERROR_TYPE
    ) {
      return (
        <Card id={this.props.problem._id} fluid raised>
          <Card.Content>
            {this.getProblemHeader()}
            {this.getProblemMeta()}
            {this.getProblemDescription()}
            {_idUpdate.includes("Update") ? (
              <>
              <br/>
                {this.getProblemHeaderUpdate()}
                {this.getProblemMetaUpdate()}
                {this.getProblemDescriptionUpdate()}
              </>
            ) : null}
          </Card.Content>
          <Card.Content extra>
            <Button
              basic
              color='green'
              fluid
              onClick={this.handleSolvedButtonClick}>
              {Strings.CHECKED}
            </Button>
          </Card.Content>
        </Card >
      );
    }
    else if (
      this.props.problem.type === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE
      || this.props.problem.type === Constants.BAD_SIGNAL_PROBLEM_TYPE
      || this.props.problem.type === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE
      || this.props.problem.type === Constants.NOISE_PROBLEM_TYPE
    ) {
      return (
        <Card id={this.props.problem._id} fluid raised>
          <Card.Content>

            {this.getProblemHeader()}
            {this.getProblemMeta()}
            {this.getProblemDescription()}

            <Card.Description>
              <p>{Strings.EVIDENCE_DESCRIPTION}</p>
              <Image
                id={this.props.problem._id + " / imgWave"}
                centered
                src={this.state.waveImg}
                style={hiddenImageStyle}
                onError={() => console.log("Error loading image")}
              />
            </Card.Description>

          </Card.Content>
          <Card.Content extra>
            <Button
              basic
              color='green'
              fluid
              onClick={this.handleSolvedButtonClick}>
              {Strings.CHECKED}
            </Button>
          </Card.Content>
          <div id="chart" style={chartsStyle}></div>
        </Card >
      );
    }
  }
}

const mapStateToProps = state => ({
  active: state
});

const mapActionsToProps = {
  onProblemSolve: solveProblemAction
};

ProblemCard.propTypes = {
  nowMillis: PropTypes.number.isRequired,
  problem: PropTypes.object.isRequired,
  onProblemSolve: PropTypes.func
};


const chartsStyle = {
  position: "absolute",
  left: "0px",
  top: "0px",
  zIndex: "-1",
  width: "525px",
  height: "250px",
  display: "none",
  visibility: "hidden"
};

const hiddenImageStyle = {
  visibility: "hidden",
  display: "none",
};


export default connect(mapStateToProps, mapActionsToProps)(ProblemCard);
